import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import styles from './styles.module.css';

export default function UpgradeBanner({ onUpgradeClick }) {
    return (
        <div className={styles.banner} onClick={onUpgradeClick} role="button" tabIndex={0}>
            <div className={styles.content}>
                <div className={styles.iconWrap}>
                    <Sparkles size={20} />
                </div>

                <div className={styles.textWrap}>
                    <p className={styles.title}>Desbloqueie todo o potencial do Orçamento Digital</p>
                    <p className={styles.subtitle}> Mais notas por semana, estoque ampliado e backup automático a partir de R$12,90/mês.</p>
                </div>

                <button className={styles.cta} onClick={onUpgradeClick}>
                    Ver planos <ArrowRight size={15} />
                </button>
            </div>
        </div>
    );
}